import { IBaseModel, BaseModel } from '../base.model';
import { IAddress } from '../address/address.model';

export interface IBlock extends IBaseModel {
  name?: string;
  fk_block_address?: string;
  fk_block_secondary_address?: string;
  zip_code?: string;
  city?: string;
  country?: string;
  attachment?: any;
  nbreLots?: number;
  digicode?: string;
  concierge?: number[];
  commercial?: number[];
  managers?: number[]
  address?: IAddress
}

export class BlockDto extends BaseModel implements IBlock {
  /**
   *
   */
  name?: string;
  fk_block_address?: string;
  fk_block_secondary_address?: string;
  zip_code?: string;
  city?: string;
  country?: string;
  attachment?: any;
  nbreLots?: number;
  digicode?: string;
  concierge?: number[];
  commercial?: number[];
  managers?: number[]
  address?: IAddress


  constructor(opt: IBlock) {
    super(opt);
    this.name = opt.name;
    this.fk_block_address = opt.fk_block_address;

  }
}


// WEBPACK FOOTER //
// ./src/models/block/block.model.ts